import { RootState } from './types'

const isLoadingApp = (state: RootState) => {
  return state.isLoadingApp
}

const snackbar = (state: RootState) => {
  return state.snackbar
}

const language = (state: RootState) => {
  return state.language
}

const headerContent = (state: RootState) => {
  return state.header.content
}

export default {
  isLoadingApp,
  snackbar,
  language,
  headerContent,
}
